export default __webpack_public_path__ + "static/media/icon-fleche-blanc.3b24a05e.svg";